import {Component} from "@angular/core";
import {AbstractFieldComponent} from "../_abstract/abstract-field.component";

@Component({
    selector: 'field-checkbox',
    templateUrl: './field-checkbox.component.html',
    styleUrls: [
        './field-checkbox.component.scss'
    ],
    standalone: false
})
export class FieldCheckboxComponent extends AbstractFieldComponent { }
